import { styled, Toolbar, Box } from '@mui/material';
import { RightToolbar } from '@homesusa/core';

const SearchFieldsStyled = styled('div')(({ theme }) => ({
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(2),
    width: 'auto'
  }
}));

const ToolBarStyled = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  rowGap: '12px',
  marginBottom: theme.spacing(1)
}));
const SearchContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end'
}));

const RightToolbarStyled = styled(RightToolbar)(() => ({
  boxShadow: 'none',
  paddingRight: '0 !important',
  alignItems: 'flex-start',
  paddingTop: '4px !important',
  '& .MuiButton-root': {
    '&:last-child': {
      marginRight: 0
    }
  }
}));

export { SearchFieldsStyled, ToolBarStyled, SearchContainer, RightToolbarStyled };
